import React from 'react';
import { cn } from '@/lib/utils';

export const EmptyState = ({ 
  icon: Icon,
  title,
  description,
  action,
  className 
}) => {
  return (
    <div className={cn('empty-state', className)} data-testid="empty-state">
      {Icon && (
        <div className="empty-state-icon">
          <Icon size={28} />
        </div>
      )}
      <h3 className="empty-state-title font-heading">{title}</h3>
      {description && (
        <p className="empty-state-description">{description}</p>
      )}
      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
